import React from 'react';

// Create StarRating component
const StarRating = ({ rating }) => {
    const maxStars = 5; // Maximum number of stars

    // Create an array for rendering stars
    const stars = [];

    for (let i = 1; i <= maxStars; i++) {
        if (i <= rating) {
            stars.push(<i key={i} className="bx bxs-star mr-2" style={{ color: '#696cff' ,"fontSize" : "20px", "marginRight" : "5px" }}></i>); // Full star
        } else if (i - rating < 1 && i > rating) {
            stars.push(<i key={i} className="bx bxs-star-half mr-2" style={{ color: '#696cff', "fontSize" : "20px", "marginRight" : "5px" }}></i>); // Half star (if needed)
        } else {
            stars.push(<i key={i} className="bx bx-star mr-2" style={{ color: '#697a8d', "fontSize" : "20px", "marginRight" : "5px" }}></i>); // Empty star
        }
    }

    return (
        <div>
            {stars}
        </div>
    );
};

export default StarRating;
